module.exports = __webpack_public_path__ + "img/social-media-discussion-dark.8632716c.svg";